import React from "react";
import { ArrowRight, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function MobilitySolutionsHero() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll();
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll();
  return <section id="mobility-solutions-hero" className="dark bg-background text-foreground relative w-full min-h-[90vh] flex flex-col lg:flex-row overflow-hidden">
      {}
      <div className="w-full lg:w-[45%] flex flex-col justify-center px-6 py-16 lg:px-12 xl:px-20 z-20 relative">
        {}
        <div className="absolute inset-0 bg-gradient-to-r from-background via-background/95 to-transparent lg:hidden -z-10" />

        <div ref={textRef} className={`transition-all duration-1000 ease-out transform ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-lg bg-primary/10 border border-primary/20 text-primary text-sm font-semibold tracking-wide mb-6 w-fit">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-lg bg-primary opacity-75"></span>
              <span className="relative inline-flex rounded-lg h-2 w-2 bg-primary"></span>
            </span>
            Premium Mobility Partner
          </div>

          <h1 className="text-5xl lg:text-6xl xl:text-7xl font-bold tracking-tight mb-6 leading-[1.1]">
            <span className="bg-gradient-to-r from-primary via-primary/80 to-primary/60 bg-clip-text text-transparent">
              Redefining
            </span>{" "}
            <br />
            Every Mile
          </h1>

          <p className="text-lg lg:text-xl text-foreground/85 font-light tracking-normal mb-10 max-w-xl leading-relaxed">
            Experience total mobility with Ledotravel. From flexible rentals to
            comprehensive corporate fleets, we drive your journey forward with
            precision, safety, and premium care.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <Button asChild size="lg" className="text-base h-12 px-8">
              <Link to="https://www.ledotravel.co.uk/car-b-van-rental/">
                Explore Rental
                <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </Button>
            <Button asChild variant="outline" size="lg" className="text-base h-12 px-8 border-primary/20 hover:bg-primary/10 hover:text-primary hover:border-primary/50 transition-colors">
              <Link to="https://www.ledotravel.co.uk/corporate-service/">
                Corporate Services
                <ChevronRight className="ml-2 h-4 w-4" />
              </Link>
            </Button>
          </div>

          {}
          <div className="mt-12 pt-8 border-t border-border/40 flex items-center gap-8 text-sm text-foreground/80">
            <div className="flex flex-col">
              <span className="font-semibold text-primary text-2xl">500+</span>
              <span>Premium Vehicles</span>
            </div>
            <div className="w-px h-10 bg-border/40" />
            <div className="flex flex-col">
              <span className="font-semibold text-primary text-2xl">24/7</span>
              <span>Support & Care</span>
            </div>
          </div>
        </div>
      </div>

      {}
      <div className="w-full lg:w-[55%] relative min-h-[50vh] lg:min-h-auto overflow-hidden" ref={imageRef}>
        {}
        <div className={`absolute inset-0 w-full h-full transition-all duration-1000 ease-out delay-300 transform ${isImageVisible ? "scale-100 opacity-100" : "scale-110 opacity-0"}`}>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1560445/img/silver_suv_hero_angled.png" alt="Premium Silver SUV - Ledotravel Fleet" className="w-full h-full object-cover object-center lg:object-left" />
        </div>

        {}
        <div className="absolute inset-0 pointer-events-none z-10">
          {}
          <div className="absolute inset-0 bg-gradient-to-t lg:bg-gradient-to-r from-background via-background/40 to-transparent lg:w-1/2" />
          
          {}
          <div className="absolute inset-0 opacity-20 bg-[radial-gradient(#3b82f6_1px,transparent_1px)] [background-size:20px_20px] [mask-image:linear-gradient(to_right,black,transparent)]" />
          
          {}
          <div className="hidden lg:block absolute top-0 bottom-0 left-0 w-px bg-gradient-to-b from-transparent via-primary/30 to-transparent" />
        </div>
      </div>
    </section>;
}